module.exports = __webpack_public_path__ + "static/media/seunghyun-hong.6c7be4ff.png";